/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum IndicatorDetailsAliases {
  AVATAR_1 = 'avatar-1',
  AVATAR_TASK = 'avatar-task',
  AVATAR_VALUE = 'avatar-value',
  BUTTON_SEND = 'button-send',
  CARD_0 = 'card-0',
  CARD_VALUES = 'card-values',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ATTACHMENTS = 'deck-attachments',
  DECK_VALUES = 'deck-values',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  FETCH_MODAL = 'fetch-modal',
  FETCH_VALUE_BY_COMPENTENCE = 'fetch-value-by-compentence',
  FETCH_VALUES = 'fetch-values',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_ATTACHMENT = 'field-attachment',
  FIELD_AVATAR = 'field-avatar',
  FIELD_AVATAR_VALUE = 'field-avatar-value',
  FIELD_CONCLUSION_DATE = 'field-conclusion-date',
  FIELD_FILTER = 'field-filter',
  FIELD_FILTER_ATTACHMENT = 'field-filter-attachment',
  FIELD_VALUE = 'field-value',
  FIELD_VALUE_INDICATOR = 'field-value-indicator',
  FILE_UPLOADER_0 = 'file-uploader-0',
  FORM_0 = 'form-0',
  FORM_ATTACHMENT = 'form-attachment',
  FORM_VALUE = 'form-value',
  FRAGMENT_0 = 'fragment-0',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  IMAGE_0 = 'image-0',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_FILTER = 'input-filter',
  INPUT_FILTER_ATTACHMENT = 'input-filter-attachment',
  LAYOUT_3 = 'layout-3',
  LAYOUT_4 = 'layout-4',
  LINK_INFORM = 'link-inform',
  MAPPER_1 = 'mapper-1',
  MAPPER_AVATAR = 'mapper-avatar',
  MAPPER_AVATAR_VALUE = 'mapper-avatar-value',
  MODAL_ATTACHMENT = 'modal-attachment',
  MODAL_VALUE = 'modal-value',
  PANEL_0 = 'panel-0',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_4 = 'panel-4',
  PANEL_ATTACHMENTS = 'panel-attachments',
  PANEL_BUTTON = 'panel-button',
  PANEL_MODAL = 'panel-modal',
  PANEL_MODAL_ATTACHMENT = 'panel-modal-attachment',
  PANEL_VALUES = 'panel-values',
  TAB_ATTACHMENTS = 'tab-attachments',
  TAB_CONTROL = 'tab-control',
  TAB_VALUES = 'tab-values',
  TAB_WITH_CONTENT_BEDS = 'tab-with-content-beds',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_VALUE_INDICATOR = 'text-value-indicator',
  TOKEN_PENDING = 'token-pending',
}
export { IndicatorDetailsAliases };
